import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFoundPage.css';

// Shown on the marketing site for any address that does not exist.
// The server still answers 200 for these (single-page app), so noindex tells Google
// not to treat the address as a real page.
export default function NotFoundPage() {
  return (
    <main className="not-found">
      <Helmet>
        <title>Page not found | EffyVenture</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <h1 className="not-found__title">This page could not be found</h1>
      <p className="not-found__text">
        The address may be typed wrong, or the page may have moved. You can start again from the home page.
      </p>
      <div className="not-found__actions">
        <Link to="/" className="btn btn-primary btn-lg">Go to home page</Link>
        <Link to="/products" className="btn btn-secondary btn-lg">See our products</Link>
      </div>
    </main>
  );
}
